// @flow
import * as React from 'react';
import { Heading, Box, Text } from 'grommet';
import { LABEL_COLOR, VALUE_COLOR } from 'esm-web-pro/components/layout/sidePanel/Attributes';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';

type Props = {
    label?: number | string | React.Node,
    text: React.Node,
    onView?: Function,
    icon?: React.Node,
}

const StyledBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
`;

const StyledHeading = styled(Heading)`
    line-height: unset;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `;

const Title = (props: Props) => {
    const {
        text, onView, icon, label,
    } = props;

    // Get ref to the div wrapping the icon so we can do some DOM manipulation to the icon and change properties.
    const iconRef = React.useRef(null);

    // If the icon is custom made SVG change fill.If the icon is grommet icon change width and height
    React.useEffect(() => {
        if (icon) {
            const currentIcon = iconRef.current.querySelector('#Layer_1-2')?.firstChild;
            if (currentIcon) {
                currentIcon.style.width = '56px';
                currentIcon.style.height = '56px';
            } else if (iconRef.current.firstChild) {
                iconRef.current.firstChild.style.width = '24px';
                iconRef.current.firstChild.style.height = '24px';
            }
        }
    }, [icon]);

    return (
        <StyledBox
            ref={iconRef}
            className="Title"
            pad={{ left: icon ? 'small' : '24px' }}
            onClick={onView}
            direction="row"
            align="center"
            background={{ color: '#fff' }}
        >
            {icon}
            <Box>
                <Text size="9px" color={LABEL_COLOR}>
                    {label}
                </Text>
                <StyledHeading
                    color={VALUE_COLOR}
                    data-tip
                    data-for="title-tooltip"
                >
                    {text}
                </StyledHeading>
                <ReactTooltip
                    id="title-tooltip"
                    effect="solid"
                    place="bottom"
                    className="react-tooltip"
                >
                    <LabelText>{text}</LabelText>
                </ReactTooltip>
            </Box>
        </StyledBox>
    );
};

Title.defaultProps = {
    label: '',
    onView: () => {},
    icon: null,
};

export default Title;
